import { useState } from "react";
import {
  browserLocalPersistence,
  createUserWithEmailAndPassword,
  setPersistence,
} from "firebase/auth";
import { auth, db } from "@/firebase/firebaseConfig";
import Button from "./UI/Button";
import { PasswordInput } from "./UI/PasswordInput";
import { FirebaseError } from "firebase/app";
import { errorMessages } from "@/assets/data/firebaseErrorMessage";
import { useTheme } from "@/utils/theme-context";
import { doc, serverTimestamp, setDoc } from "firebase/firestore";

const Registration = () => {
  const [registerPassword, setRegisterPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [registerEmail, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const register = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setLoading(true);

    try {
      await setPersistence(auth, browserLocalPersistence);

      if (registerPassword === confirmPassword) {
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          registerEmail,
          confirmPassword
        );

        const user = userCredential.user;
        const userDocRef = doc(db, "users", user.uid);

        const userData = {
          createdAt: serverTimestamp(),
          email: registerEmail,
          uid: user.uid,
          isVerified: false,
          maxModules: 4,
          completedLessons: {
            [`module00Lesson00`]: true,
          },
          access: [
            "course",
            "productList",
            "bonusLessons",
            "ai",
            "invest",
            "telegram",
            "orders",
            "speakers",
          ],
        };

        await setDoc(userDocRef, userData);

        setLoading(false);
        setErrorMessage("");
      } else {
        setLoading(false);
        setErrorMessage("Пароли не совпадают. Попробуйте еще раз");
        console.log(errorMessage);
      }
    } catch (error) {
      setLoading(false);

      // Обработка ошибок Firebase
      if (error instanceof FirebaseError) {
        setErrorMessage(errorMessages[error.message] || errorMessages.default);
      } else {
        setErrorMessage(errorMessages.default);
      }
    }
  };

  const { theme } = useTheme();

  return (
    <>
      <p className="authentication-box__title">Новый аккаунт</p>

      <input
        className={`input  input--${theme} `}
        required
        id="email"
        name="email"
        type="email"
        placeholder="Ваша почта"
        onChange={(event) => setEmail(event.target.value)}
      />
      {errorMessage && (
        <p className="authentication-box__error"> {errorMessage} </p>
      )}
      <div className="authentication-box-passwords">
        <div className="authentication-box-passwords-item">
          <PasswordInput
            value={registerPassword}
            onChange={setRegisterPassword}
            placeholder={""}
          />
        </div>
        <div className="authentication-box-passwords-item">
          <PasswordInput
            value={confirmPassword}
            onChange={setConfirmPassword}
            placeholder="Повторите пароль"
          />
        </div>
      </div>
      <p className="authentication-box__desc">
        Пароль должен состоять минимум из 6 символов.
      </p>

      {loading ? (
        <Button
          title="Зарегистрироваться"
          color="black"
          disabled
          onClick={register}
        />
      ) : (
        <Button title="Зарегистрироваться" color="black" onClick={register} />
      )}

      <p className="authentication-box__text">
        Уже есть аккаунт?{" "}
        <a className="authentication-box__link" href="/auth/sign-in">
          Войти
        </a>
      </p>
      <p className="authentication-box__politika">
        {" "}
        Нажимая на кнопку "Зарегистрироваться" - вы соглашаетесь с нашей{" "}
        <a href="/politika.pdf" target="_blank">
          Политикой конфиденциальности
        </a>{" "}
        и{" "}
        <a href="/oferta.pdf" target="_blank">
          Публичной офертой
        </a>
      </p>
    </>
  );
};

export default Registration;
